export default {
  namespace:true,
  state:{
    dataCategory:{
      'spend':'推广花费',
      'revenue':'广告变现',
      'purchase':'内购变现',
      'ecpm':'ECPM',
      'roi_model':'ROI & ROAS',
      'ltv_model':'LTV',
      'product':'产品数据',
      'dau':'留存',
      'new':'新用户',
      'rate':'比率',
      'compose':'组合指标'
    },
    panelType:{
      'public':'公开',
      'private':'私有',
      'protected':'保护',
    },
  },
  mutations:{},
  getters:{
    getDataCategory:state => {
      return state.dataCategory
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/reportSotre.js